<template>
  <div id="finance-manage" class="app-main-content">
    <div v-show="showMainList" class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          :is-collapse-list="true"
          :grid-options="gridOptions"
          :is-append-query="true"
          :is-simple-query.sync="isSimpleQuery"
          :auto-init="false"
          :show-more-scheme="true"
          :show-simple="true"
          :expand-adv="true"
          source-page="finance"
          reset
          :lob="sopStateLob"
          :custom-search-items="customSearchItems"
          :search-item-code="$t('CargoMsg.Cargo_FinancialAudit')"
          :is-branch-cooperate="useOrderCenterMode"
          :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
          config-module="501"
          grid-config-module="180301"
          @query="queryHandler"
          @advToggle="scrollCallback"
          @perConfigChange="value=>{perConfigName=value}"
          @refreshGrid="()=>{gridRefreshId+=1}"
          @sopStateCallBack="sopStateChange"
        >
          <template slot="operations">
            <finance-btn-group source-view="manageList" :job="job" :hp="financeManageHP" :grid-options="gridOptions" />
          </template>
        </search-item>
        <div class="section grid-wrapper" style="min-height:350px">
          <cargo-ag-grid-wrapper
            config-module="180301"
            :per-config-name="perConfigName"
            :refresh-id="gridRefreshId"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :check-main-record="false"
            :deselect-main-record="false"
            :column-defs="columnDefs"
            :sum-column-defs="sumColumnDefs"
            :row-data="rowData"
            :wrap-text="false"
            :enable-quick-value-convert="true"
            :show-selected-color="false"
            style="width: 100%;"
            :show-row-groups="dataListDragGroup"
            :darg-group-show-column-def="dargGroupShowColumnDef"
            @girdReady="onGridReady"
            @columnRowGroupChanged="() => { this.$refs['searchItem'].clickCollapseList() }"
          />
        </div>
        <div id="footer-wrapper" class="pagination-wrapper">
          <div :class="[shouldFixed?'fixedBottom':'']" class="total-wrapper">
            <span v-show="showSelectionCount">
              {{ selectionCountLabel }}
            </span>
            <charge-currency-total-group
              v-if="reCalc"
              :key="1"
              class="finance-currency-total-group"
              :amount-to-currency="localCurrency"
              mode="simple"
              :data-field="chargeCalculateAmount ? 'income' : 'incomeNoTax'"
              type="both"
              :data-provider="financeManageHP.totalGroupIncome.dataProvider"
              currency-field="currency"
              :amount-to-currency-label="$t('CargoMsg.Cargo_Receivable')"
              @callback="incomeCallback"
            />
            <charge-currency-total-group
              v-if="reCalc"
              :key="2"
              class="finance-currency-total-group"
              :amount-to-currency="localCurrency"
              mode="simple"
              :data-field="chargeCalculateAmount ? 'cost' : 'costNoTax'"
              type="both"
              :data-provider="financeManageHP.totalGroupCost.dataProvider"
              currency-field="currency"
              :amount-to-currency-label="$t('CargoMsg.Cargo_Dues')"
            />
            <charge-currency-total-group
              v-if="reCalc"
              :key="3"
              class="finance-currency-total-group"
              :amount-to-currency="localCurrency"
              mode="simple"
              :data-field="chargeCalculateAmount ? 'realProfit' : 'realProfitNoTax'"
              type="both"
              :data-provider="financeManageHP.totalGroup.dataProvider"
              currency-field="currency"
              :amount-to-currency-label="$t('CargoMsg.Cargo_Profit')"
              @callback="profitCallback"
            />
            <div v-if="reCalc" class="finance-profit-rate">
              <span style="font-weight: bold;font-size: 13px;">{{ $t('queryJob.grossProfitRate') }}:</span>
              <span :style="{'font-style': 'oblique', 'color': profitRate.value < 0 ? '#ff0000' : '#000000'}">{{ profitRate.label }}</span>
            </div>
            <charge-count-group
              v-if="reCalc"
              class="finance-charge-count-group"
              :data-provider="financeManageHP.chargeCountGroup.dataProvider"
              :data-field="chargeCalculateAmount ? 'charge_amount' : 'charge_amount_no_tax'"
              :basic-currency="localCurrency"
              :new-by-job="3"
              :show-rmb="true"
              :always-show="false"
            />
          </div>
          <cargo-pagination
            v-show="!appendQuery"
            config-module="180301"
            :total="searchConditions.total"
            :page-count="searchConditions.pageCount"
            :page.sync="searchConditions.pageNum"
            :limit.sync="searchConditions.pageSize"
            @pagination="queryPageHandler"
          />
          <div v-show="appendQuery" class="pagination-container">
            <el-pagination
              style="text-align: left;"
              :total="searchConditions.total"
              layout="total"
            />
          </div>
        </div>
      </div>
    </div>
    <!--详情-->
    <finance-detail v-show="showDetail" ref="financeDetail" :view-source="detailViewSource" @backList="toBackList" @exportAll2Excel="exportAll2Excel" />
    <!--业务提成-->
    <business-commission v-show="showBusinessCommission" ref="businessCommission" :visible.sync="showBusinessCommission" @viewDetail="showDetail4BusinessCommission" @backList="showBusinessCommission=false" />
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!--批量更新汇率-->
    <update-exchange-rate-dialog
      :visible.sync="updateExchangeRateDialog.visible"
      :job-key-list="updateExchangeRateDialog.jobKeyList"
      :location="location"
    />
    <!-- SOP操作状态弹窗 -->
    <div class="sop-state-wrapper-grid">
      <sop-state-dialog
        :visible.sync="sopStateDialog.visible"
        :is-need-refresh.sync="sopStateDialog.isNeedRefresh"
        :job="currentRow"
        @handleClose="sopStateDialogClose"
      />
    </div>
  </div>
</template>

<script>

// utils
import URL from '@/api/urlTranslator'
import lodash from 'lodash'
import { DocumentManage, stopBubble } from '@/utils/commonUtil'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import OperatorConstants from '@/class/cargo/model/parameters/OperatorConstants'
import * as ChargeConstants from '@/class/cargo/model/parameters/ChargeConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import * as AdvancedSearchConsts from '@/class/cargo/model/utils/AdvancedSearchConsts'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import moment from 'moment'
import ChargeCountGroup from '@/components/Cargo/Act/chargeSummary/ChargeCountGroup.vue'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'

// components
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import financeBtnGroup from './components/financeManage/financeBtnGroup'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoDropdownMenu from '@/components/Cargo/Common/CargoDropdownMenu'
import FinanceDetail from './components/financeManage/financeDetail'
import businessCommission from './components/financeManage/businessCommission'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import checkDialog from './components/financeManage/checkDialog'
import changeDialog from './components/financeManage/changeDialog'
import provisionedDialog from './components/financeManage/changeDialog'
import cancelProvisionedDialog from './components/financeManage/changeDialog'
import businessDateDialog from './components/financeManage/changeDialog'
import lockOrderDialog from './components/financeManage/lockOrderDialog'

import FinanceManageHP from './components/financeManage/financeManageHp.js'
import updateExchangeRateDialog from '@/views/cargo/v0/Clearing/components/financeManage/updateExchangeRateDialog'
import { User } from '@/class/model/sys/User'
import { getObjectByCache, getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as SeaExportConstants from '@/class/cargo/model/parameters/SeaExportConstants'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { cache, cacheName } from '@/utils/cacheManager'
import { LOG_FINANCIAL_REVIEW } from '@/class/cargo/model/parameters/SystemConstants'
import * as NumberUtils from '@/utils/NumberUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import sopStateDialog from '@/components/Cargo/Job/sopStateDialog'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'FinanceManage',
  components: { ChargeCurrencyTotalGroup, ChargeCountGroup, cargoAdvanceSelect, financeBtnGroup, checkDialog, cancelProvisionedDialog, changeDialog, provisionedDialog, businessDateDialog, lockOrderDialog, searchItem, FinanceDetail, businessCommission, cargoDropdownMenu, cargoTemplateSelectorDialog, updateExchangeRateDialog, cargoAgGridWrapper, sopStateDialog },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      routeJobNo: '',
      defActiveTab: 'tabCharges',
      selectedJob: {},
      customConditions: [],
      jobStates: [], // 业务状态
      isAr: -1, //  是否应收
      hasBillPayment: -1, // 是否有付款申请
      showTotalProfit: true, // 显示总利润 (全量数据)
      showCostColumn: true, // 是否显示总成本
      showRevenueColumn: true, // 是否显示总收入
      showVoucherDate: false, // 显示生成凭证日期
      hasCheckRole: true, // 是否根据权限查询数据
      allJobByRole: false, // 查看所有业务
      showFba: false, // 显示FBA相关列
      searchExportExcel: false, // 全部数据，用于导出
      departmentJobByRole: false, // 查看同组业务
      userJobByRole: false, // 查看自己业务
      departmentTeamUser: [], // 同部门的人

      job: {}, // todo
      customSearchItems: [], // 自定义高级查询项
      financeManageHP: new FinanceManageHP(this),
      loading: false,
      isSimpleQuery: false,
      showCheckDialog: false,
      showChangeDialog: false,
      showLockOrderDialog: false,
      showProvisionedDialog: false,
      showCancelProvisionedDialog: false,
      showBusinessDateDialog: false,

      showControlledProfit: false,

      url: URL,
      showDetail: false,
      showBusinessCommission: false,
      documentManage: new DocumentManage(),
      detailViewSource: '', // detailView详情页的来源
      currentChooseRow: {},
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        cxt: null,
        category: 'JOBLIST',
        data: {
          JOB_UUID: [],
          LOB: 'SE'
        }
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      searchConditions: {
        total: 0, // total传递到后端无用
        pageCount: 0, // pageCount传递到后端无用
        pageNum: 1,
        pageSize: 50,
        simpleTriggerMode: false, // 是否为简单查询触发模式
        snapshotConditions: [], // 高级查询条件（点击查询时的快照状态）
        requires: []
      },
      perConfigName: '',
      gridRefreshId: 0,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        // 参考 BookingNew 的列表滚动配置，保留虚拟滚动并增加缓冲，降低快速滚动白屏概率。
        rowBuffer: 5,
        suppressRowVirtualisation: false,
        suppressColumnVirtualisation: false,
        suppressAnimationFrame: false,
        getRowId: params => params?.data?.uuid || params?.data?.jobNo,
        onRowDoubleClicked: this.showDetailView4Manage
      },
      gridParams: {},
      gridApi: {},
      dargGroupShowColumnDef: {
        headerName: this.$t('queryJob.businessNumber'),
        field: 'jobNo',
        colId: 'jobNo',
        width: 240,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: params => true,
        wrapText: false,
        cellRenderer: params => {
          const methodPath = this.documentManage.getPath('showTemplateDialog')
          return `${params.value}<i class="el-icon-search" onclick="${methodPath}('${params.data.uuid}')" style="color:#46a6ff;cursor:pointer"/>`
        },
        excelRenderer: params => params.value
      },
      columnDefs: [{ headerName: this.$t('queryJob.businessNumber'), field: 'jobNo', width: 180 }],
      sumColumnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      simpleTriggerMode: false, // 记录上一次的查询条件，导出全部使用
      beforeConditions: null, // 记录上一次的查询条件，导出全部使用
      shouldFixed: false,
      showSelectionCount: true,
      selectionCountLabel: '',
      updateExchangeRateDialog: {
        visible: false,
        jobKeyList: []
      },
      appendQuery: false, // 追加查询
      voucherPage: 0,
      chargeCalculateAmount: true, // 费用是否使用含税价计算
      useOrderCenterMode: false, // 是否开启接单中心模式
      branchCooperate: false, // 本公司协助业务
      jinRongExchangeMode: false, // 锦荣交单模式
      enableCommission: false,
      queryChildernDataRole: false,
      financeManageQueryChildData: false,
      includeChildOfficeData: false, // 是否包含下属公司数据
      incomeTotal: 0, // 应收总计
      profitTotal: 0, // 利润总计
      profitRate: { // 毛利率
        value: 0,
        label: '0.00'
      },
      zy: false, // 中邮
      hm: false,
      isSpecialExpenseEntryFunction: false, // 专项费用录入功能配置
      jobAndChargeSubmitterAndAuditorCanNotSame: false, // 业务和者费用的提交人与审核人不可以相同
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      currentRow: {},
      sopStateDialog: {
        visible: false,
        isNeedRefresh: false
      },
      sopStateLob: 'SE' // 业务状态追踪对应的业务类型
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail && !this.showBusinessCommission
    },
    location() {
      return LOG_FINANCIAL_REVIEW.code
    }
  },
  watch: {
    // isSimpleQuery: {
    //   async handler(newVal) {
    //     if (!newVal && this.customSearchItems.length === 0) {
    //       await this.financeManageHP.initializeHandler()
    //     }
    //   },
    //   immediate: true
    // }
    rowData(newVal) {
      if ((!newVal || newVal.length === 0) && this.routeJobNo) {
        this.$message.error(this.$t('Clearing.YouPermissionToViewData'))
      }
    },
    '$store.getters.currentOfficeId': {
      async handler() {
        await cache.load(cacheName.CONFIG)
        this.jinRongExchangeMode = cache.config.get('ToExoSystem') === 'JinRongExchangeMode' // 锦荣交单模式
        this.zy = cache.config.get('ToExoSystem') === 'zy'
        this.enableCommission = cache.config.get('enableCommission') === '1'
        this.queryChildernDataRole = cache.config.get('QueryChildernDataRole') === '1'
        this.financeManageQueryChildData = cache.config.get('FinanceManageQueryChildData') === '1'
        this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
        const newIncludeChildOfficeData = this.enableCommission ? this.queryChildernDataRole : this.financeManageQueryChildData
        if (newIncludeChildOfficeData || this.includeChildOfficeData) {
          this.includeChildOfficeData = newIncludeChildOfficeData
          await this.getSearchField()
        } else {
          this.includeChildOfficeData = newIncludeChildOfficeData
        }
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    const { query, params } = to
    if (Object.keys(query).length > 0) {
      next({ name: 'FinanceManage', params: { ...params, ...query }})
    } else {
      next()
    }
  },
  created() {
    this.financeManageHP.created()
    this.financeManageHP.initializeHandler()
    this.setLocalCurrency()
  },
  beforeMount() {
    this.financeManageHP.beforeMount()
  },
  async mounted() {
    await cache.load(cacheName.CONFIG)
    this.jinRongExchangeMode = cache.config.get('ToExoSystem') === 'JinRongExchangeMode' // 锦荣交单模式
    this.zy = cache.config.get('ToExoSystem') === 'zy'
    this.hm = cache.config.get('ToExoSystem') === 'HONGMING'
    this.enableCommission = cache.config.get('enableCommission') === '1'
    this.queryChildernDataRole = cache.config.get('QueryChildernDataRole') === '1'
    this.financeManageQueryChildData = cache.config.get('FinanceManageQueryChildData') === '1'
    this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
    this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
    this.includeChildOfficeData = this.enableCommission ? this.queryChildernDataRole : this.financeManageQueryChildData
    this.jobAndChargeSubmitterAndAuditorCanNotSame = cache.config.get('JobAndChargeSubmitterAndAuditorCanNotSame') === '1'
    this.getSearchField()
    if (this.$route.params.jobNo) {
      this.routeJobDetails(this.$route.params.jobNo)
      delete this.$route.params.jobNo
    }
    this.scrollCallback()
    document.querySelector('.app-main-content').addEventListener('scroll', this.scrollCallback)
  },
  activated() {
    if (this.$route.params.billPaymentNo) {
      const conditions = [{ fieldType: 'FIELD_TEXT', fieldName: 'billPayment.billpaymentno', operator: '=', value: this.$route.params.billPaymentNo }]
      this.queryHandler({ simpleTriggerMode: false, conditions })
    } else if (this.$route.params.jobNo) {
      this.routeJobDetails(this.$route.params.jobNo)
      delete this.$route.params.jobNo
    } else if (this.$route.query.jobNo) {
      this.routeJobDetails(this.$route.query.jobNo)
    }
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  destroyed() {
    document.querySelector('.app-main-content').removeEventListener('scroll', this.scrollCallback, false)
  },
  methods: {
    // 财务审核页筛选值变化事件
    filterChange() {
      this.$nextTick(() => {
        const hasDisplay = []
        this.gridOptions.api.forEachNode(node => {
          if (!node.data) {
            return
          }
          if (node.displayed) {
            hasDisplay.push(node.data)
          }
        })
        if (hasDisplay.length > 0) {
          if (hasDisplay.length === this.rowData.length) {
            this.showTotalProfit = true
          }
          if (hasDisplay.length < this.rowData.length) {
            this.showTotalProfit = false
          }
        } else {
          this.showTotalProfit = false
        }
        this.financeManageHP.refreshSelectedCount()
      })
    },
    onGridReady(params) {
      this.gridApi = params.api
    },
    routeJobDetails(jobNo) {
      this.routeJobNo = jobNo
      const { params } = this.$route
      if (params.activeTabName) {
        this.defActiveTab = params.activeTabName
      }
      if (params.defActiveTab) {
        if (params.defActiveTab === '国内账单') {
          this.defActiveTab = 'tabInternalBill'
        } else if (params.defActiveTab === '国外账单') {
          this.defActiveTab = 'tabOverseaBill'
        }
      }
      this.queryHandler({ simpleTriggerMode: true, conditions: this.routeJobNo })
    },
    async getSearchField() {
      this.customSearchItems = []
      // 业务日期
      let searchField = new AdvancedSearchField()
      searchField.itemType = 'date'
      searchField.itemCondition = []
      searchField.defaultConditionVal = 'RANGE'
      searchField.fieldType = 'FIELD_DATE_RANGE'
      searchField.itemName = 'job.business_date'
      searchField.itemLabel = 'queryJob.businessDate'
      const startDate = moment().subtract(1, 'months').format('YYYY-MM-DD') // 当前时间的前一个月时间
      searchField.itemValue = [startDate]
      searchField.subType = 'range'
      searchField.defaultSelected = 1
      searchField.selected = 0
      searchField.lock = false
      searchField.defaultValue = []
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      this.customSearchItems.push(searchField.formatObj2Json())
      // 航线负责人
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'advanceSelect'
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemName = 'job.PLANNER'
      searchField.itemLabel = 'SeaExport.AirlinePerson2'
      searchField.tagValue = 'userId'
      searchField.defaultSelected = 0
      searchField.subType = { filterable: true }
      // 取出海运、空运航线负责人，并去重
      const promise = await Promise.all([
        User.getUsersByPrivilegeDetail('role', 'sealine'),
        User.getUsersByPrivilegeDetail('role', 'airline')
      ])
      const users = promise[0]
      const airLineUsers = promise[1]
      const keys = users.map(user => user.uuid)
      for (const user of airLineUsers) {
        if (!keys.includes(user.uuid)) {
          users.push(user)
        }
      }
      searchField.dataProvider = users
      this.customSearchItems.push(searchField.formatObj2Json())
      // 自定义业务类型
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'cutomJobType'
      searchField.subType = 'cascader'
      searchField.fieldType = 'FIELD_CUTOM_JOB_TYPE_ALL'
      searchField.itemCondition = []
      searchField.defaultConditionVal = '='
      searchField.itemName = 'job.custom_job_type'
      searchField.itemLabel = 'queryJob.customJobType'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = 'uuid'
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      this.customSearchItems.push(searchField.formatObj2Json())

      // 提单种类
      const billTypes = BillType.BILL_TYPE_VALUES.map(item => {
        return { code: item.serialNumber, chineseName: item.localName, englishName: item.name }
      })
      // MBL提单种类
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'job.TYPE_MBL'
      searchField.itemLabel = 'SeaExport.MBLBlProperty'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = billTypes
      this.customSearchItems.push(searchField.formatObj2Json())

      // HBL提单种类
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.multiple = 1
      searchField.itemCondition = []
      searchField.defaultConditionVal = ''
      searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
      searchField.itemName = 'job.TYPE_HBL'
      searchField.itemLabel = 'SeaExport.HBLBlProperty'
      searchField.itemValue = []
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.dropdownDataRef = ''
      searchField.lock = false
      searchField.defaultValue = []
      searchField.dataProvider = billTypes
      this.customSearchItems.push(searchField.formatObj2Json())

      // 销售主管计提
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL]
      searchField.defaultConditionVal = '='
      searchField.itemName = 'provisionHistory.SALES_SUPERVISOR_PROVISION'
      searchField.itemLabel = 'CargoMsg.Cargo_SalesSupervisorProvision'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = ''
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      this.customSearchItems.push(searchField.formatObj2Json())

      // 操作主管计提
      searchField = new AdvancedSearchField()
      searchField.action = AdvancedSearchField.UPDATE_ACTION
      searchField.itemType = 'select'
      searchField.fieldType = 'FIELD_CHECKBOX'
      searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL]
      searchField.defaultConditionVal = '='
      searchField.itemName = 'provisionHistory.OP_SUPERVISOR_PROVISION'
      searchField.itemLabel = 'CargoMsg.Cargo_OperationSupervisorProvision'
      searchField.itemValue = ''
      searchField.defaultSelected = 0
      searchField.selected = 0
      searchField.tagValue = ''
      searchField.tagName = ''
      searchField.lock = false
      searchField.defaultValue = ''
      searchField.dropdownDataRef = 'RadioStatusConstants.YES_NO_TYPES'
      searchField.dataCacheKey = 'local_cache_RadioStatusConstants$YES_NO_TYPES'
      this.customSearchItems.push(searchField.formatObj2Json())
      if (this.includeChildOfficeData) {
        const isHQ = this.$store.getters.currentOfficeId === 1
        const officeIdsForRole = this.getChildOfficeIds(this.$store.getters.currentOfficeUuid)
        const officeIdTxtsRole = officeIdsForRole.length > 0 ? officeIdsForRole.join(',') : ''
        this.customSearchItems.push({
          action: AdvancedSearchField.UPDATE_ACTION,
          itemType: 'user',
          fieldType: 'FIELD_USER',
          subType: {
            category: 'role',
            shape: 'userDefinedRole4',
            officeId: '',
            officeIds: isHQ ? '' : officeIdTxtsRole
          },
          itemCondition: [],
          defaultConditionVal: '',
          itemName: 'job.user_defined_role_id_4',
          itemLabel: '海外跟单',
          itemValue: '',
          defaultSelected: 0,
          selected: 0,
          valueExpression: '',
          lock: false,
          defaultValue: ''
        })
      } else {
        this.customSearchItems.push({
          action: AdvancedSearchField.UPDATE_ACTION,
          itemType: 'user',
          fieldType: 'FIELD_USER',
          subType: {
            category: 'role',
            shape: 'userDefinedRole4'
          },
          itemCondition: [],
          defaultConditionVal: '',
          itemName: 'job.user_defined_role_id_4',
          itemLabel: '海外跟单',
          itemValue: '',
          defaultSelected: 0,
          selected: 0,
          valueExpression: '',
          lock: false,
          defaultValue: ''
        })
      }
      if (this.useOrderCenterMode) {
        const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
        const offices = officeAll.filter(p => p.code !== 'HQ').sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
        offices.forEach(row => { row.code = row.officeId }) // ID
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BRANCH_ID'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBranchId'
        searchField.itemValue = []
        searchField.tagValue = 'officeId'
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = offices
        this.customSearchItems.push(searchField.formatObj2Json())
        // 协作业务类型
        const cooperationTypes = getCacheListByKey(basicCacheKeys.basic_data_CooperationType)
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'cooperate.BUSINESS_TYPE'
        searchField.itemLabel = 'CargoMsg.Cargo_CooperateBusinessType'
        searchField.itemValue = []
        searchField.defaultSelected = 1
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = cooperationTypes
        this.customSearchItems.push(searchField.formatObj2Json())
      }
      if (this.jinRongExchangeMode) {
        // 云平台同步状态
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = 0
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'statistic.finance_cloud_sync_status'
        searchField.itemLabel = 'CargoMsg.Cargo_CloudPlatformSyncStatus'
        searchField.itemValue = []
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.dropdownDataRef = ''
        searchField.lock = false
        searchField.defaultValue = []
        searchField.dataProvider = ChargeConstants.JOB_JDYXK_SYNC_STATUS
        this.customSearchItems.push(searchField.formatObj2Json())
      }
      if (this.hm) {
        // 泓明：对接费用接口
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL]
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'job._hmPushExternalInterfaceStatus_'
        searchField.itemLabel = 'Clearing.PushState'
        searchField.dataProvider = ChargeConstants.ZY_INTERFACE_PUSH_STATUS
        this.customSearchItems.push(searchField.formatObj2Json())
      }
      if (this.zy) {
        // 中邮推送外部接口状态
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'select'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL]
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'job._zyPushExternalInterfaceStatus_'
        searchField.itemLabel = 'Clearing.NewGeneration'
        searchField.dataProvider = ChargeConstants.ZY_INTERFACE_PUSH_STATUS
        this.customSearchItems.push(searchField.formatObj2Json())
        // 中邮-可售卖产品和国内国外
        const saleProductList = getFilterCacheList(TYPE_NAMES.basic_data_AllowSaleProduct, (mapping) => {
          return mapping.statusEnabled === true
        })
        // 可售卖产品
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST_NOT_CONVERT'
        searchField.itemName = 'job.SALE_PRODUCT_CODE'
        searchField.itemLabel = 'CargoMsg.AllowSaleProduct'
        searchField.tagValue = 'productCode'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = saleProductList
        this.customSearchItems.push(searchField.formatObj2Json())

        // 全程/国内
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.ADD_ACTION
        searchField.itemType = 'advanceSelect2'
        searchField.multiple = 1
        searchField.itemCondition = [AdvancedSearchConsts.OPERATOR_EQUAL, AdvancedSearchConsts.OPERATOR_UNEQUAL, AdvancedSearchConsts.OPERATOR_IN]
        searchField.defaultConditionVal = ''
        searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
        searchField.itemName = 'job.FULL_OR_INSIDE'
        searchField.itemLabel = 'CargoMsg.FullOrInside'
        searchField.tagValue = 'code'
        searchField.defaultSelected = 0
        searchField.selected = 0
        searchField.defaultValue = ''
        searchField.dataProvider = Array.from(SystemConstants.FULL_OR_INSIDE)
        this.customSearchItems.push(searchField.formatObj2Json())
      } else {
        // 中邮推送外部接口状态
        searchField = new AdvancedSearchField()
        searchField.action = AdvancedSearchField.REMOVE_ACTION
        searchField.itemType = 'select'
        searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
        searchField.itemName = 'job._zyPushExternalInterfaceStatus_'
        this.customSearchItems.push(searchField.formatObj2Json())
      }
      if (this.includeChildOfficeData) {
        const isHQ = this.$store.getters.currentOfficeId === 1
        const officeIds = this.getChildOfficeIds(this.$store.getters.currentOfficeUuid)
        const officeIdTxts = officeIds.length > 0 ? officeIds.join(',') : ''
        this.customSearchItems.push(
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'allOfficeUser',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'shape': 'csr',
              'officeId': '',
              'officeIds': isHQ ? '' : officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.csr_id',
            'itemLabel': 'queryJob.CustomerService',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'allOfficeUser',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'shape': 'doc',
              'officeId': '',
              'officeIds': isHQ ? '' : officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.dc_id',
            'itemLabel': 'queryJob.Documents',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'allOfficeUser',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'shape': 'op',
              'officeId': '',
              'officeIds': isHQ ? '' : officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.op_id',
            'itemLabel': 'queryJob.operation',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'allOfficeUser',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'shape': 'sales',
              'officeId': '',
              'officeIds': isHQ ? '' : officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.sales_id',
            'itemLabel': 'queryJob.sales',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'officeId': '',
              'officeIds': officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.created_by',
            'itemLabel': 'queryJob.creator',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'shape': 'overseaOp',
              'officeId': '',
              'officeIds': officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.oversea_op',
            'itemLabel': 'SeaExport.OverseaCustomerService',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_SALES_OF_GOODS',
            'subType': {
              'category': 'role',
              'shape': 'salesOfGoods',
              'officeId': '',
              'officeIds': officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.cargo_sales_id',
            'itemLabel': 'SeaExport.SalesOfGoods',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'officeId': '',
              'officeIds': officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.PRE_COMMIT_USER',
            'itemLabel': 'SeaExport.PreCommitUser',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'officeId': '',
              'officeIds': officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.COMMIT_USER',
            'itemLabel': 'SeaExport.CommitUser',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'officeId': '',
              'officeIds': officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.LOCK_JOB_USER',
            'itemLabel': 'SeaExport.LockJobUser',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'officeId': '',
              'officeIds': officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'charge.CREATED_BY',
            'itemLabel': 'Payment.inputBy',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'userSea',
            'fieldType': 'FIELD_USER_SEA',
            'subType': {
              'category': 'role',
              'shape': 'siteOp',
              'officeId': '',
              'officeIds': officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.SITE_OP',
            'itemLabel': 'SeaExport.FieldOperation',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'officeId': '',
              'officeIds': officeIdTxts
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.PREVERIFIER',
            'itemLabel': 'SeaExport.PreAuditPerson',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'department4',
            'fieldType': 'FIELD_DEPARTMENT',
            'multiple': 1,
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.sales_dept',
            'itemLabel': 'queryJob.salesDepartment',
            'itemValue': [],
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': []
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'department4',
            'fieldType': 'FIELD_DEPARTMENT5',
            'multiple': 1,
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.CSR_DEPT',
            'itemLabel': 'Message.Customer_Service',
            'itemValue': [],
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'headers': [],
            'fields': [],
            'tagValue': '',
            'tagName': '',
            'lock': false,
            'defaultValue': []
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'department4',
            'fieldType': 'FIELD_DEPARTMENT5',
            'multiple': 1,
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.DC_DEPT',
            'itemLabel': 'Message.Documentation_Department',
            'itemValue': [],
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'headers': [],
            'fields': [],
            'tagValue': '',
            'tagName': '',
            'lock': false,
            'defaultValue': []
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'office',
            'subType': {
              'includeChildOffice': true // 是否包含下属公司
            },
            'fieldType': 'FIELD_OP_OFFICE',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.OP_OFFICE',
            'itemLabel': 'SeaExport.opOffice',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'office',
            'subType': {
              'includeChildOffice': true // 是否包含下属公司
            },
            'fieldType': 'FIELD_SALES_OFFICE',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.sales_office',
            'itemLabel': 'SeaExport.salesOffice',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'company',
            'subType': {
              'type': 'customer',
              'tagValue': 'cmpIdx',
              'officeIds': officeIds
            },
            'fieldType': 'FIELD_CUSTOMER',
            'itemCondition': [{
              'code': '=',
              'chineseName': '等于',
              'englishName': 'Equal',
              'children': null,
              'selected': false
            }, {
              'code': '!=',
              'chineseName': '不等于',
              'englishName': 'Unequal',
              'children': null,
              'selected': false
            }, {
              'code': 'IN',
              'chineseName': '包含',
              'englishName': 'In',
              'children': null,
              'selected': false
            }],
            'defaultConditionVal': '',
            'itemName': 'job.customer_id',
            'itemLabel': 'queryJob.consignationCompany',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'company',
            'subType': {
              'type': 'bookingAgent',
              'tagValue': 'cmpIdx',
              'officeIds': officeIds
            },
            'fieldType': 'FIELD_BOOKING_AGENT',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.booking_agent',
            'itemLabel': 'queryJob.bookingAgent',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'company',
            'subType': {
              'type': 'overseaAgent',
              'tagValue': 'cmpIdx',
              'officeIds': officeIds
            },
            'fieldType': 'FIELD_SEA_DEST_AGENT',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.destination_agent',
            'itemLabel': 'queryJob.destinationAgent',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'company',
            'subType': {
              'type': 'designationAgent',
              'tagValue': 'cmpIdx',
              'officeIds': officeIds
            },
            'fieldType': 'FIELD_SEA_DESIGNATION_AGENT',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.designation_agent',
            'itemLabel': 'queryJob.nominatedAgent',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'company',
            'subType': {
              'type': '',
              'tagValue': 'cmpIdx',
              'officeIds': officeIds
            },
            'fieldType': 'FIELD_CUSTOMER_BROKER',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.CUSTOMS_BROKER',
            'itemLabel': 'SeaExport.CustomsBroker',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          }
        )
      } else {
        this.customSearchItems.push(
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'allOfficeUser',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'shape': 'csr'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.csr_id',
            'itemLabel': 'queryJob.CustomerService',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'allOfficeUser',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'shape': 'doc'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.dc_id',
            'itemLabel': 'queryJob.Documents',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'allOfficeUser',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'shape': 'op'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.op_id',
            'itemLabel': 'queryJob.operation',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'allOfficeUser',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'shape': 'sales'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.sales_id',
            'itemLabel': 'queryJob.sales',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.created_by',
            'itemLabel': 'queryJob.creator',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role',
              'shape': 'overseaOp'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.oversea_op',
            'itemLabel': 'SeaExport.OverseaCustomerService',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_SALES_OF_GOODS',
            'subType': {
              'category': 'role',
              'shape': 'salesOfGoods'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.cargo_sales_id',
            'itemLabel': 'SeaExport.SalesOfGoods',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.PRE_COMMIT_USER',
            'itemLabel': 'SeaExport.PreCommitUser',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.COMMIT_USER',
            'itemLabel': 'SeaExport.CommitUser',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.LOCK_JOB_USER',
            'itemLabel': 'SeaExport.LockJobUser',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'charge.CREATED_BY',
            'itemLabel': 'Payment.inputBy',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'userSea',
            'fieldType': 'FIELD_USER_SEA',
            'subType': {
              'category': 'role',
              'shape': 'siteOp'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.SITE_OP',
            'itemLabel': 'SeaExport.FieldOperation',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'user',
            'fieldType': 'FIELD_USER',
            'subType': {
              'category': 'role'
            },
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.PREVERIFIER',
            'itemLabel': 'SeaExport.PreAuditPerson',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'department5',
            'fieldType': 'FIELD_DEPARTMENT',
            'multiple': 1,
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.sales_dept',
            'itemLabel': 'queryJob.salesDepartment',
            'itemValue': [],
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': []
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'department5',
            'fieldType': 'FIELD_DEPARTMENT5',
            'multiple': 1,
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.CSR_DEPT',
            'itemLabel': 'Message.Customer_Service',
            'itemValue': [],
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'headers': [],
            'fields': [],
            'tagValue': '',
            'tagName': '',
            'lock': false,
            'defaultValue': []
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'department5',
            'fieldType': 'FIELD_DEPARTMENT5',
            'multiple': 1,
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.DC_DEPT',
            'itemLabel': 'Message.Documentation_Department',
            'itemValue': [],
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'headers': [],
            'fields': [],
            'tagValue': '',
            'tagName': '',
            'lock': false,
            'defaultValue': []
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'office',
            'subType': {},
            'fieldType': 'FIELD_OP_OFFICE',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.OP_OFFICE',
            'itemLabel': 'SeaExport.opOffice',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'office',
            'subType': {},
            'fieldType': 'FIELD_SALES_OFFICE',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.sales_office',
            'itemLabel': 'SeaExport.salesOffice',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'company',
            'subType': {
              'type': 'customer',
              'tagValue': 'cmpIdx'
            },
            'fieldType': 'FIELD_CUSTOMER',
            'itemCondition': [{
              'code': '=',
              'chineseName': '等于',
              'englishName': 'Equal',
              'children': null,
              'selected': false
            }, {
              'code': '!=',
              'chineseName': '不等于',
              'englishName': 'Unequal',
              'children': null,
              'selected': false
            }, {
              'code': 'IN',
              'chineseName': '包含',
              'englishName': 'In',
              'children': null,
              'selected': false
            }],
            'defaultConditionVal': '',
            'itemName': 'job.customer_id',
            'itemLabel': 'queryJob.consignationCompany',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'company',
            'subType': {
              'type': 'bookingAgent',
              'tagValue': 'cmpIdx'
            },
            'fieldType': 'FIELD_BOOKING_AGENT',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.booking_agent',
            'itemLabel': 'queryJob.bookingAgent',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'company',
            'subType': {
              'type': 'overseaAgent',
              'tagValue': 'cmpIdx'
            },
            'fieldType': 'FIELD_SEA_DEST_AGENT',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.destination_agent',
            'itemLabel': 'queryJob.destinationAgent',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'company',
            'subType': {
              'type': 'designationAgent',
              'tagValue': 'cmpIdx'
            },
            'fieldType': 'FIELD_SEA_DESIGNATION_AGENT',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.designation_agent',
            'itemLabel': 'queryJob.nominatedAgent',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          },
          {
            'action': AdvancedSearchField.UPDATE_ACTION,
            'itemType': 'company',
            'subType': {
              'type': '',
              'tagValue': 'cmpIdx'
            },
            'fieldType': 'FIELD_CUSTOMER_BROKER',
            'itemCondition': [],
            'defaultConditionVal': '',
            'itemName': 'job.CUSTOMS_BROKER',
            'itemLabel': 'SeaExport.CustomsBroker',
            'itemValue': '',
            'defaultSelected': 0,
            'selected': 0,
            'valueExpression': '',
            'lock': false,
            'defaultValue': ''
          }
        )
      }
    },
    getChildOfficeIds(officeUuid) {
      const allOffice = [...getCacheListByKey(basicCacheKeys.basic_data_Office_All)]
      allOffice.sort((a, b) => a.level - b.level)
      const keySet = new Set([officeUuid])
      const officeIds = []
      for (const office of allOffice) {
        if (keySet.has(office.uuid)) {
          officeIds.push(office.officeId)
        } else if (office.parentBranchUuid && keySet.has(office.parentBranchUuid)) {
          keySet.add(office.uuid)
          officeIds.push(office.officeId)
        }
      }
      return officeIds
    },
    // 分页触发查询
    queryPageHandler() {
      this.searchExportExcel = false
      this.financeManageHP.doSearchWithProfitAndList()
    },
    // 导出全部
    exportAll2Excel(type) {
      this.financeManageHP.exportExcelAllClickHandler(type)
    },
    // 查询触发
    queryHandler({ simpleTriggerMode, conditions }) {
      JobUtils.handleTrackingInfoMultipleState(conditions, this.sopStateLob)
      this.searchExportExcel = false
      this.simpleTriggerMode = simpleTriggerMode// 简单查询导出全部
      this.beforeConditions = conditions// 简单查询导出全部
      this.search2({ simpleTriggerMode, conditions })
    },
    search2({ simpleTriggerMode, conditions }) {
      this.searchConditions.pageNum = 1
      const finallyConditions = []
      this.searchConditions.simpleTriggerMode = simpleTriggerMode
      if (this.searchConditions.simpleTriggerMode) {
        this.appendQuery = false // 关闭追加查询
        this.branchCooperate = false
        if (!conditions) {
          this.$message.warning(this.$t('FinanceManage.finance_inputBusinessNumber'))
          return
        }

        if (this.routeJobNo) { // 跳转查询直接根据jobNo精确查询
          const arry = this.routeJobNo.split(',')
          const option = new AdvancedSearchOption(null, 'job.job_no', arry, OperatorConstants.OPERATOR_BATCH.code)
          finallyConditions.push(option.formatObj2Json())
        } else {
          // 简单查询，则 combiConditions为string
          const option = new AdvancedSearchOption(null, 'job.job_no', conditions.trim(), OperatorConstants.OPERATOR_LIKE.code)
          finallyConditions.push(option.formatObj2Json())
        }
      } else {
        // 高级查询条件组装
        const advConditions = conditions ? lodash.cloneDeep(conditions) : []
        if (AdvancedSearchOption.hasField('charge.offset_state', advConditions)) {
          const option = AdvancedSearchOption.getOption('charge.offset_state', advConditions)
          if (option.value === false) {
            option.value = ChargeConstants.OFFSET_STATE_NORMAL.code
          } else {
            option.operator = OperatorConstants.OPERATOR_IN.code
            option.value = `${ChargeConstants.OFFSET_STATE_HEDGE.code}, ${ChargeConstants.OFFSET_STATE_BE_HEDGE.code}`
          }
          // 更新某一項
          AdvancedSearchOption.updateOption(option, advConditions)
        }
        if (AdvancedSearchOption.hasField('job.job_state', advConditions)) {
          const option = AdvancedSearchOption.getOption('job.job_state', advConditions)
          if (option.operator === OperatorConstants.OPERATOR_NOT_IN.code) {
            const optionList = option.value
            optionList.push(-1)
            optionList.push(12)
            option.value = optionList
            // 更新某一項
            AdvancedSearchOption.updateOption(option, advConditions)
          }
        }
        const lcOption = AdvancedSearchOption.getOption('job.localSevice', advConditions)
        if (lcOption != null) {
          const codes = lcOption.value
          const services = []
          for (const code of codes) {
            const service = CommonState.getStateByCode(SeaExportConstants.STUFFY_TYPES, code)
            if (service != null) services.push(service)
          }
          const stuffingTypes = this.convertStuffyTypeToQuery(services)
          for (const stuffing in stuffingTypes) {
            advConditions.push(new AdvancedSearchOption(null, stuffingTypes[stuffing], true).formatObj2Json())
          }
        }
        if (AdvancedSearchOption.hasField('job.localSevice', advConditions)) {
          AdvancedSearchOption.removeOption('job.localSevice', advConditions)
        }
        if (AdvancedSearchOption.hasField('job.custom_job_type', advConditions)) {
          const option = AdvancedSearchOption.removeOption('job.custom_job_type', advConditions)
          option.fieldName = 'job.CUSTOM_JOB_TYPE'
          const customJobType = getObjectByCache(basicCacheKeys.basic_data_CutomJobType, 'uuid', option.value)
          if (customJobType) {
            option.value = [customJobType.type, customJobType.code]
          }
          // 重新加入
          advConditions.push(option)
        }
        const loadAssociatedJob = AdvancedSearchOption.getOption('loadAssociatedJob', advConditions)
        if (loadAssociatedJob && loadAssociatedJob.value) {
          if (!AdvancedSearchOption.hasField('job.job_no', advConditions)) {
            this.$message.warning(this.$t('FinanceManage.EnterBusinessNumberBeforeQuery'))
            return
          }
        }
        // 获取追加查询条件
        advConditions.forEach((element, index) => {
          if (Object.prototype.hasOwnProperty.call(element, 'appendQuery')) {
            this.appendQuery = element.appendQuery
            advConditions.splice(index, 1)
          }
        })
        // 本公司协助业务
        advConditions.forEach((element, index) => {
          if (Object.prototype.hasOwnProperty.call(element, 'branchCooperate')) {
            this.branchCooperate = element.branchCooperate
            advConditions.splice(index, 1)
          }
        })
        finallyConditions.push(...advConditions)
      }
      this.toSupplementConditionsBeforeQuery(finallyConditions)
      // 条件保存
      this.searchConditions.snapshotConditions = finallyConditions
      // 查询列表+利润
      this.financeManageHP.doSearchWithProfitAndList()
    },
    // 本地服务条件处理
    convertStuffyTypeToQuery(items) {
      const result = []
      for (const stuffyType of items) {
        if (stuffyType.code === 'IS') {
          result.push('job.WAREHOUSING')
        } else if (stuffyType.code === 'DD') {
          result.push('job.LAND_TRANSPORTATION')
        } else if (stuffyType.code === 'SD') {
          result.push('job.SELF_DELIVER')
        } else if (stuffyType.code === 'CT') {
          result.push('seaJob.CUSTOMS')
        } else if (stuffyType.code === 'HT') {
          result.push('seaJob.HEATING')
        } else if (stuffyType.code === 'CIT') {
          result.push('seaJob.COMERCIAL_INSPECTATION')
        } else if (stuffyType.code === 'AMS') {
          result.push('seaJob.AMS')
        } else if (stuffyType.code === 'ISBOOKING') {
          result.push('job.BOOKING')
        }
      }
      return result
    },
    // 查询请求前补充条件
    toSupplementConditionsBeforeQuery(finallyConditions) {
      if (this.customConditions && this.customConditions.length > 0) { finallyConditions.push(...this.customConditions) }

      if (this.jobStates && this.jobStates.length > 0 && !LoadDefaultQueryParam.isSelectOption(finallyConditions, 'job.job_state')) {
        const option = new AdvancedSearchOption(null, 'job.job_state', LoadDefaultQueryParam.convertCommonStateToInt(this.job_states), AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      } else if (!AdvancedSearchOption.hasField('job.job_state', finallyConditions)) {
        const option = new AdvancedSearchOption(null, 'job.job_state', LoadDefaultQueryParam.convertCommonStateToInt(SystemConstants.JOB_STATES), AdvancedSearchConsts.OPERATOR_IN.code)
        finallyConditions.push(option.formatObj2Json())
      }

      if (this.hasBillPayment !== -1) {
        finallyConditions.push(new AdvancedSearchOption(null, 'charge.bill_payment_uuid', null, this.hasBillPayment === 0 ? AdvancedSearchConsts.OPERATOR_IS_NULL.code : AdvancedSearchConsts.OPERATOR_IS_NOT_NULL.code).formatObj2Json())
      }
      this.$logger.log('finallyConditions4=====', finallyConditions)
      if (this.isAr !== -1) { finallyConditions.push(new AdvancedSearchOption(null, 'charge.receivable', Number(this.isAr) === 1).formatObj2Json()) }

      // 是否显示关联业务  后端此查询条件做特殊处理了，如果不传默认为true，故前端无需处理
      // if (AdvancedSearchOption.hasField(SpecialFieldConstants.LOAD_RELATION_JOBS, conditions)) {
      //   var option:AdvancedSearchOption = AdvancedSearchOption.getOption(SpecialFieldConstants.LOAD_RELATION_JOBS, conditions);
      //   super.loadRelationJobs = option.value;
      // } else {
      //   super.loadRelationJobs = true;
      // }
      const requires = []
      if (this.showRevenueColumn || this.showCostColumn) { requires.push('revenue') }
      if (this.showVoucherDate) { requires.push('voucherDate') }
      if (this.showTotalProfit) { requires.push('showTotalProfit') }
      if (this.showFba) { requires.push('fba') }
      if (this.jinRongExchangeMode) {
        requires.push('jinRongExchangeMode')
      }
      if (this.hm) {
        requires.push('hmPushExternalInterfaceStatus')
      }
      requires.push('invoiceCreatedBy')
      if (this.zy) {
        requires.push('zyPushExternalInterfaceStatus')
      }
      if (this.isSpecialExpenseEntryFunction) {
        requires.push('specialCharge')
      }
      const colorType = Number(this.$store.state.settings.colorType) === 1
      if (colorType) {
        requires.push('financeColor')
      }
      this.searchConditions.requires = requires
    },
    // 业务编号旁的搜索按钮事件
    showTemplateDialog(e) {
      // TemplateSelectorWin.getInstance().showThisWin(data as AbstractEntity, "JOB_DETAIL_OP", {"JOB_UUID":data.key}, FlexGlobals.topLevelApplication as DisplayObject);
      stopBubble(e)
      if (!this.selectedJob) return
      this.templateSelectorDialog.cxt = this.selectedJob
      this.templateSelectorDialog.category = 'JOB_DETAIL_OP'
      this.templateSelectorDialog.data = { 'JOB_UUID': this.selectedJob.uuid }
      this.templateSelectorDialog.visible = true
    },
    async showDetailView4Manage({ data } = {}, needChecked = false) {
      if (!needChecked && !data) {
        return
      }
      const newRowData = []
      this.gridOptions.api.forEachNodeAfterFilterAndSort(node => {
        if (node.data) {
          newRowData.push(node.data)
        }
      })
      this.financeManageHP.showDetailView(needChecked, { ...data }, this.gridOptions, newRowData)
    },
    toBackList(toView) {
      this.showDetail = false
      this.queryPageHandler()
      if (toView === 'manageList') {
        this.showBusinessCommission = false
      } else {
        this.showBusinessCommission = true
      }
    },
    showDetail4BusinessCommission({ detailData, treeDataArr, fromView }) {
      this.detailViewSource = fromView
      this.showDetail = true
      this.$nextTick(() => {
        this.$refs.financeDetail.showDetail(detailData, treeDataArr)
      })
    },
    scrollCallback() {
      if (this._scrollTicking) {
        return
      }
      this._scrollTicking = true
      window.requestAnimationFrame(() => {
        this._scrollTicking = false
        const container = document.querySelector('.app-main-content')
        const footer = document.getElementById('footer-wrapper')
        if (!container || !footer) {
          return
        }
        const containerHeight = container.clientHeight - footer.offsetHeight
        const offset = footer.offsetTop - container.scrollTop
        const shouldFixed = offset > containerHeight + 50
        if (shouldFixed !== this.shouldFixed) {
          this.shouldFixed = shouldFixed
        }
      })
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    // 是否协作业务
    isCooperate(cooperateStatus) {
      if (cooperateStatus !== -1 && this.useOrderCenterMode) {
        return true
      }
      return false
    },
    incomeCallback(data) {
      this.incomeTotal = 0
      if (data && data.length > 0) {
        const amountLabel = typeof data[0].amount === 'object' ? data[0].amount.toFormat(2) : String(data[0].amount)
        if (amountLabel !== 'Infinity') {
          this.incomeTotal = Number(amountLabel.replaceAll(',', ''))
        }
      }
      this.caculateProfitRate()
    },
    profitCallback(data) {
      this.profitTotal = 0
      if (data && data.length > 0) {
        const amountLabel = typeof data[0].amount === 'object' ? data[0].amount.toFormat(2) : String(data[0].amount)
        if (amountLabel !== 'Infinity') {
          this.profitTotal = Number(amountLabel.replaceAll(',', ''))
        }
      }
      this.caculateProfitRate()
    },
    caculateProfitRate() {
      if (this.incomeTotal !== 0) {
        this.profitRate.value = Number(NumberUtils.ToFixed2(this.profitTotal / this.incomeTotal * 100, 2))
        this.profitRate.label = this.profitRate.value.toFixed(2) + '%'
      } else {
        this.profitRate.value = this.profitTotal
        this.profitRate.label = this.profitTotal.toFixed(2)
      }
    },
    sopStateDialogClose() {
      LocalStorageUtils.setConfiguration('FinanceSopStatusPopupVisible', false)
    },
    // 查询条件选择状态追踪的时候，触发回调事件
    sopStateChange(data) {
      if (data) {
        this.sopStateLob = data
      }
    }
  }
}
</script>

<style lang="scss">
#footer-wrapper {
  align-items: center;

  .total-wrapper {
    align-items: center;
    gap: 4px 0;
    max-width: 100%;
  }

  .finance-currency-total-group {
    max-width: 100%;
    padding-right: 10px;
    white-space: normal;

    > div {
      flex-wrap: wrap;
      justify-content: flex-end !important;
      row-gap: 4px;
    }
  }

  .finance-profit-rate {
    display: flex;
    flex: 0 0 auto;
    padding-left: 5px;
    padding-right: 10px;
    white-space: nowrap;
  }

  .finance-charge-count-group {
    flex-wrap: wrap;
    justify-content: flex-end !important;
    max-width: 100%;
    row-gap: 4px;
    white-space: normal;
  }

  .fixedBottom {
    position: fixed;
    bottom: 0;
    left: 15px;
    right: 15px;
    background: #fff;
    max-width: calc(100vw - 30px);
    z-index: 10;
  }
}
.sop-state-wrapper-grid {
  .el-dialog {
    position: fixed;
    top: unset;
    bottom: 0;
    left: 50%;
    margin-left: -225px;
    height: 80vh;
    margin-bottom: 0;

    .el-dialog__body {
      padding: 5px;
    }
  }
}
</style>
